import { omitBy } from 'lodash';

const isEmptyValue = val => val === undefined || val === null || val === '';

/**
 * Local replacement for @leagueplatform/web-common's omitKeysWithEmptyValues.
 * The web-common version uses lodash-es chain() which breaks under production
 * tree-shaking because chained methods like omitBy may not be available.
 */
export const omitKeysWithEmptyValues = (data = {}) =>
  omitBy(data, isEmptyValue);
